import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconFastTurns = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="M12.21 6.204a.652.652 0 0 1 0 .993l-4.895 4.079c-.417.349-1.085.054-1.085-.51V8.512c-3.031.348-4.227 1.583-3.143 4.884.14.43-.389.778-.778.51C1.085 13.047 0 11.41 0 9.773 0 6.23 2.615 5.13 6.23 4.862V2.634c0-.537.668-.832 1.085-.483l4.895 4.053Zm3.56 0c.306.268.306.724 0 1.02l-4.895 4.052c-.417.349-1.084.054-1.084-.483v-.43l4.366-3.65-4.366-3.676v-.403c0-.537.667-.832 1.084-.483l4.896 4.053Z"
    />
  </svg>
));
export default SvgIconFastTurns;
